import { render, staticRenderFns } from "./BookingCompletion.vue?vue&type=template&id=72d84123&"
import script from "./BookingCompletion.vue?vue&type=script&lang=js&"
export * from "./BookingCompletion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports